import Skeleton from "../../common/Skeleton";

interface TableSkeletonProps {
  rows?: number;
}

const TableSkeleton = ({ rows = 5 }: TableSkeletonProps) => {
  return (
    <>
      {[...Array(rows)].map((_, index) => (
        <tr
          key={index}
          className="border-b border-[#d0d4e4] dark:border-[#394564]"
        >
          {/* Symbol */}
          <td className="py-2 px-4">
            <div className="flex items-center justify-between w-full min-w-[140px]">
              <div className="flex flex-col gap-1.5">
                <div className="flex items-center gap-1.5">
                  <Skeleton className="w-3 h-3 rounded-sm" />
                  <Skeleton className="w-24 h-4 rounded" />
                </div>
                <Skeleton className="w-20 h-3 rounded ml-4" />
              </div>
              <Skeleton className="w-4 h-4 rounded-full ml-4" />
            </div>
          </td>
          {/* Risk Profile */}
          <td className="py-2 px-2 text-center">
            <Skeleton className="w-10 h-4 mx-auto rounded" />
          </td>
          {/* Close */}
          <td className="py-2 px-2 text-center">
            <Skeleton className="w-16 h-4 mx-auto rounded" />
          </td>
          {/* 52w High (Price / % Var) */}
          <td className="py-2 px-2 text-center">
            <div className="flex flex-col gap-2 items-center">
              <Skeleton className="w-12 h-4 rounded" />
              <Skeleton className="w-16 h-4 rounded" />
            </div>
          </td>
          {/* Probability */}
          <td className="py-2 px-2 text-center">
            <Skeleton className="w-12 h-4 mx-auto rounded" />
          </td>
          {/* RSI (Daily/Weekly/Monthly) */}
          <td className="py-2 px-0">
            <div className="flex justify-around space-x-1">
              <Skeleton className="w-10 h-4 rounded-full" />
              <Skeleton className="w-10 h-4 rounded-full" />
              <Skeleton className="w-10 h-4 rounded-full" />
            </div>
          </td>
          {/* Peak Return */}
          <td className="py-2 px-2 text-center">
            <div className="flex flex-col gap-2 items-center">
              <Skeleton className="w-12 h-4 rounded" />
              <Skeleton className="w-16 h-4 rounded" />
            </div>
          </td>
          {/* Current Return */}
          <td className="py-2 px-2 text-center">
            <div className="flex flex-col gap-2 items-center">
              <Skeleton className="w-12 h-4 rounded" />
              <Skeleton className="w-16 h-4 rounded" />
            </div>
          </td>
          {/* Scores */}
          <td className="py-2 px-1 text-center">
            <Skeleton className="w-[46px] h-[28px] mx-auto rounded-t-full" />
          </td>
          <td className="py-2 px-1 text-center">
            <Skeleton className="w-[46px] h-[28px] mx-auto rounded-t-full" />
          </td>
          <td className="py-2 px-1 text-center">
            <Skeleton className="w-[46px] h-[28px] mx-auto rounded-t-full" />
          </td>
          <td className="py-2 px-1 text-center">
            <Skeleton className="w-12 h-4 mx-auto rounded" />
          </td>
          {/* Action */}
          <td className="py-2 px-3 text-center">
            <div className="flex justify-center space-x-2">
              <Skeleton className="w-5 h-5 rounded-full" />
              <Skeleton className="w-5 h-5 rounded-full" />
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default TableSkeleton;
